<fullscreen-page>
  <dx-splitter>
    <dxi-splitter-item [collapsible]="true" size="33%">
      <navigation-column style="flex: 1 1;">
        <div class="h-100 d-flex flex-column">

          <div class="px-3 pt-3 pb-2">
            <div class="browse-filter-header">
              <dx-text-box class="browse-search"
                           mode="search"
                           [showClearButton]="true"
                           placeholder="{{ 'Produkte suchen' | translate }}"
                           [(value)]="searchText"
                           (onInput)="onSearchInput($event)">
              </dx-text-box>

            <dx-button class="dx-button-text-left"
                     text="{{ 'Erweitert' | translate }}"
                     type="default"
                     stylingMode="text"
                     (onClick)="toggleFilter()"
                     icon="{{modelService.catalogService.showFilter ? 'chevrondown' : 'chevronleft' }}"/>
        </div>

        <div *ngIf="modelService.catalogService.showFilter">
          <dx-tabs class="np-clean-tabs"
                   [dataSource]="filterTabs"
                   [selectedIndex]="activeFilterTabIndex"
                   [scrollByContent]="false"
                   [showNavButtons]="false"
                   (onItemClick)="onFilterTabChanged($event.itemIndex)">
          </dx-tabs>

          <div *ngIf="activeFilterTabIndex === 0" class="pt-2">
            <productStateOptions [stateValue]="selectedStates"
                                 (onValueChanged)="updateState($event)">
            </productStateOptions>
            <productSearchOptions></productSearchOptions>
          </div>

          <div *ngIf="activeFilterTabIndex === 1" class="pt-2">
            <searchFormOptions
                (onEditSearchForm)="toggleSeachFormPopup()"
                (onExecuteSearchForm)="executeSearchForm()">
            </searchFormOptions>
          </div>
        </div>
      </div>

          <div class="px-2 flex-fill np-nav-scroll">
            <dx-tree-list id="treelist" class="tree"
                          [dataSource]="dataSource"
                          [showBorders]="false"
                          [showColumnHeaders]="false"
                          [showColumnLines]="false"
                          [remoteOperations]="{ filtering: true }"
                          [showRowLines]="false"
                          [rowAlternationEnabled]="true"
                          [hoverStateEnabled]="true"
                          keyExpr="treeElementId"
                          parentIdExpr="parent"
                          hasItemsExpr="hasChilds"
                          rootValue="0"
                          (onSelectionChanged)="onSelectItem($event)"
                          [(selectedRowKeys)]="treeSelectedRowKeys"
                          (onCellPrepared)="onCellPrepared($event)"
                          (onInitialized)="saveGridInstance($event)"
                          (onContentReady)="onContentReady($event)">

              <dxo-search-panel [visible]="false"
                                placeholder="{{ 'Produkte suchen' | translate }}"
                                width="auto"
                                [(text)]="searchText">
              </dxo-search-panel>

              <dxo-scrolling mode="virtual" showScrollbar="always"></dxo-scrolling>
              <dxo-selection [mode]="treeListMode()" [recursive]="!isSearch(undefined)"></dxo-selection>
              <dxi-column dataField="Title" cellTemplate="cellTemplate"></dxi-column>
              <dxi-column dataField="order" [visible]=false sortOrder="asc"></dxi-column>
              <div *dxTemplate="let itemObj of 'cellTemplate'">
                <div class="treeitem" id="image{{itemObj.data.treeElementId}}">
                  <div class="container-fluid h-100">
                    <div class="row h-100 d-flex">
                      <div class="col order-0 treeitemimage d-flex align-items-center position-relative">
                        <span *ngIf="!itemObj.data.imageUrl" class="glyphicon glyphicon-picture" style="font-size: 36px;"></span>
                        <img *ngIf="itemObj.data.imageUrl" src="{{itemObj.data.imageUrl}}" style="height: 40px;"/>
                        <div *ngIf="itemObj.data.type != 'cat'" class="type-indicator" [ngClass]="{ 'type-pro': itemObj.data.type === 'pro','type-grp': itemObj.data.type === 'grp'}"></div>
                      </div>

                      <div *ngIf="itemObj.data.type === 'cat'" class="col order-2 treeitemlanguage">
                        <dx-select-box *ngIf="showTranslateBox()"
                                       [dataSource]="languageFlags"
                                       displayExpr="language"
                                       valueExpr="code"
                                       [(value)]="selectedTranslateLanguage"
                                       fieldTemplate="field" style="height: 27px; width: 37px; top: 6px;">
                          <div *dxTemplate="let data of 'item'">
                            <div class="custom-item" style="margin-left: -10px;">
                              <img src="images/flags/{{data?.flag}}" class="flag"/>
                            </div>
                          </div>
                          <div *dxTemplate="let data of 'field'">
                            <div class="custom-item">
                              <img src="images/flags/{{data?.flag}}" class="flag"/>
                              <dx-text-box [value]="data?.text" [readOnly]="true" style="display: none"></dx-text-box>
                            </div>
                          </div>
                        </dx-select-box>
                      </div>
                      <div class="col order-1 overflow-hidden treeitemtext">
                        <div class="treeitemheader">
                          {{ itemObj.data.text }}
                        </div>
                        <div class="treeitemdetail">
                          <div [ngSwitch]="itemObj.data.type">
                            <!--CATALOG-->
                            <div *ngSwitchCase="'cat'">
                              {{ 'Kategorien' | translate }}: {{ itemObj.data.categoryCount }} - {{ 'Produkte' | translate }}: {{ itemObj.data.productCount }} ({{ 'eindeutige' | translate }}: {{ itemObj.data.uniqueProductCount }})
                            </div>

                            <!--CATEGORY-->
                            <div *ngSwitchCase="'grp'">
                              {{ 'Kategorien' | translate }}: {{ itemObj.data.categoryCount }} - {{ 'Produkte' | translate }}: {{ itemObj.data.productCount }}
                            </div>
                            <!--PRODUCT-->
                            <div *ngSwitchCase="'pro'">
                              {{ itemObj.data.supplierPid }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <dx-context-menu [dataSource]="menuItems"
                                 [width]="200"
                                 (onShowing)="onContextMenuShowing($event,itemObj)"
                                 target="#image{{itemObj.data.treeElementId}}"
                                 id="context{{itemObj.data.treeElementId}}"
                                 (onItemClick)="itemClick($event,itemObj)">
                  <div *dxTemplate="let e of 'item'">
                    <div>
                      <span [ngClass]="e.icon"></span>
                      <span *ngIf="e.items" class="dx-icon-spinright"></span> {{ e.text }}
                    </div>
                  </div>
                </dx-context-menu>
              </div>
            </dx-tree-list>
          </div>
        </div>
      </navigation-column>
    </dxi-splitter-item>
    <dxi-splitter-item [collapsible]="true">
      <content-column look="light">
        <logo slot="toolbar" [routerLink]="['/catalogs']" look="light"></logo>

        <div slot="content" class="np-content-scroll">
          <catalogDetail *ngIf="isCatalogSelected && !massDataChange && !massGenerateKITexts" (onMassDataEdit)="setEmptyProduct($event)"></catalogDetail>
          <categoryDetail *ngIf="isCategorySelected && !massDataChange && !massGenerateKITexts" (onMassDataEdit)="setEmptyProduct($event)"></categoryDetail>
          <productDetail *ngIf="isProductSelected && !massDataChange && !massGenerateKITexts" (onMassDataEdit)="setEmptyProduct($event)"></productDetail>
          <massDataChange *ngIf="massDataChange" [treeList]="treeList" [emptyProduct]="emptyProduct" (cancel)="massCancel($event)"></massDataChange>
          <massGenerateKIText *ngIf="massGenerateKITexts" [treeList]="treeList" (cancel)="startMassGenerateKITexts()"></massGenerateKIText>
        </div>
      </content-column>
    </dxi-splitter-item>
  </dx-splitter>
</fullscreen-page>

<np-dialog [popupWidth]="500" [popupHeight]="300" [popupTitle]="'Info' | translate"
           [(popupVisible)]="showInfoForOnboardingUser">
  <div slot="content" class="w-100 h-100">
    <p>{{ 'Die Artikel des Katalogs sollten in die Zielstruktur überführt werden' | translate }}.</p>
    <p>{{ 'Hierzu können Sie die Funktion "Kataloge kombinieren verwenden' | translate }}."</p>

    <np-dialog-button slot="toolbar" toolbar="bottom" location="after" widget="dxButton"
                      [options]="{ stylingMode: 'outlined', text: 'Kataloge Kombinieren öffnen' | translate, onClick: showCombineCatalog }"></np-dialog-button>
    <np-dialog-button slot="toolbar" toolbar="bottom" location="after" widget="dxButton"
                      [options]="{ stylingMode: 'outlined', text: 'Später durchführen' | translate, onClick: hideInfoDialog }"></np-dialog-button>
  </div>
</np-dialog>

<np-dialog
    [popupWidth]="1250" [popupHeight]="900" [popupTitle]="'Suchformular editieren' | translate"
    [(popupVisible)]="searchFormPopupVisible">
    <div slot="content">
    <np-search-forms
        (onCancel)="searchFormPopupVisible = false"
    ></np-search-forms>
    </div>
</np-dialog>